/**
 * ProjectList Component
 */

import { ListItemAnimations } from '../../../utils/animation';
import { IProjectItemProps, removeProject, selector, shareProject, submitForm } from './form';
import './project-list.scss';

import { differenceWith, isEqual } from 'lodash';
import * as nextTick from 'next-tick';
import * as React from 'react';
import * as BEM from 'react-bem-helper';
import { connect } from 'react-redux';
import { FieldArray, WrappedFieldArrayProps } from 'redux-form';
import { VelocityTransitionGroup } from 'velocity-react';

import ProjectButton from './projectList/ProjectButton';

interface IOwnStateProps {
  projectList: IProjectItemProps[];
}

interface IOwnProps {
  onDeleteProject: (projectId: string) => void;
  onSelectProject: (projectId: string) => void;
}

type ProjectListProps = IOwnProps & IOwnStateProps & IDispatchProps;

const ProjectListAnimation = ListItemAnimations(128);
const classes = new BEM('project-list');

class ProjectList extends React.Component<ProjectListProps, {}> {

  onDelete = (id: string) => {
    const index = this.props.projectList.findIndex(({ id: projectId }) => projectId === id);
    this.props.dispatch(removeProject(index));
    this.props.onDeleteProject(id);
    nextTick(() => this.props.dispatch(submitForm()));
  }

  onShareProject = () => {
    this.props.dispatch(shareProject());
    nextTick(() => {
      this.props.dispatch(submitForm());
    });
  }

  renderProjectButtonList(listTitle: string, projects: IProjectItemProps[]) {
    return (
      <VelocityTransitionGroup
        component="ul"
        enter={{ animation: ProjectListAnimation.In, stagger: 150 }}
        leave={{ animation: ProjectListAnimation.Out }}
        data-title={listTitle}
        {...classes()}
        runOnMount
      >
      {projects.map((project, index) => {
        return (
          <li key={project.id} {...classes('item')}>
            <ProjectButton
              index={index}
              onSelect={this.props.onSelectProject}
              onDelete={this.onDelete}
              onShare={this.onShareProject}
              {...project}
            />
          </li>
        );
      })}
      </VelocityTransitionGroup>
    );
  }

  renderProjectButtons = ({ fields }: WrappedFieldArrayProps<IProjectItemProps>) => {
    const allProjects = fields.getAll();

    if (!allProjects) {
      return null;
    }

    const sharedProjects = allProjects.filter((project) => project.isPublic);
    const privateProjects = differenceWith(allProjects, sharedProjects, isEqual);

    return (
      <>
        {!!sharedProjects.length && this.renderProjectButtonList('Shared Playlists', sharedProjects)}
        {!!privateProjects.length && this.renderProjectButtonList('Private Playlists', privateProjects)}
      </>
    );
  }

  render() {
    return (
      <div {...classes('wrapper')}>
        <FieldArray
          name="projects"
          component={this.renderProjectButtons}
        />
      </div>
    );
  }
}

const ConnectedProjectList = connect<IOwnStateProps, {}, IOwnProps, IStoreState>(
  (state) => ({
    projectList: selector(state, 'projects'),
  }),
)(ProjectList);

export default ConnectedProjectList;



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--0!./src/public/components/pages/Projects/ProjectList.tsx